import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import FeaturePlatform from './Pages/FeaturePlatform';
import Dashboard from './Pages/Dashboard';
import Banner from './Pages/Banner';
import FAQs from './Pages/FAQs';
import ContactUs from './Pages/ContactUs';
import Deposit from './Pages/Deposit';
import Credit from './Pages/Credit';
import Promotions from './Pages/Promotions';
import AdminLogin from './Pages/AdminLogin';
import { ConfigProvider } from "antd";


function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(true);

    useEffect(() => {
        const loggedIn = localStorage.getItem('isLoggedIn'); // or localStorage based on your preference
        setIsAuthenticated(loggedIn === 'true' || false); // Update the state based on the stored value
        console.log('Logged In:', loggedIn);
    }, []);

    useEffect(() => {
        console.log('Authenticated state:', isAuthenticated);
    }, [isAuthenticated]); // This will log when isAuthenticated changes

    return (
        <Router>
            <Routes>
                {/* Public route for login */}
                <Route path="/" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />

                {/* Protected routes - only accessible if authenticated */}
                <Route
                    path="/"
                // element={isAuthenticated ? <Navigate to="/Dashboard" /> : <Navigate to="/Admin-Login" />}
                >
                    {/* Main Layout for all authenticated routes */}
                    <Route element={<ConfigProvider
                        theme={{
                            token: {
                                colorPrimary: "#FE0000", // Bootstrap warning color
                                colorBgMenuItemSelected: "#FE0000", // Selected item background
                                colorBgMenuItemHover: "#FE0000", // Hover item background
                            },
                        }}
                    >
                        <MainLayout />
                    </ConfigProvider>}>
                        <Route path="Dashboard" element={<Dashboard />} />
                        <Route path="FeaturePlatform" element={<FeaturePlatform />} />
                        <Route path="Banner" element={<Banner />} />
                        <Route path="FAQs" element={<FAQs />} />
                        <Route path="ContactUs" element={<ContactUs />} />
                        <Route path="Deposit" element={<Deposit />} />
                        <Route path="Credit" element={<Credit />} />
                        <Route path="Promotions" element={<Promotions />} />
                    </Route>
                </Route>

                {/* Catch-all for non-existing routes */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;
